import React from "react";
import "./App.css";
import { FiMail, FiPhone } from "react-icons/fi";

export default function App() {
  return (
    <div className="app">

      {/* ================= NAVBAR ================= */}
      <nav className="navbar">
        <div className="nav-left">
          <img src="/logo.png" alt="Logo" className="logo" />
          <h2 className="brand">ZestyClothes</h2>
        </div>

        <ul className="menu">
          <li><a href="#hero">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#testimonials">Testimonials</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>

      {/* ================= HERO ================= */}
      <section id="hero" className="hero">
        <div className="hero-text">
          <h1 className="title">
            Elevate Your Style with <span>ZestyClothes</span>
          </h1>

          <p className="desc">
            Discover premium bow ties crafted for elegance and sophistication.
            Whether it's a wedding, corporate event, or special occasion,
            we ensure you look your absolute best.
          </p>

          <div className="btn-group">
            <button className="btn-primary">Explore Collection</button>
            <button className="btn-secondary">Contact Us</button>
          </div>

          <div className="stats">
            <div>
              <h2>10K+</h2>
              <p>Satisfied Clients</p>
            </div>

            <div>
              <h2>5K+</h2>
              <p>Events Styled</p>
            </div>

            <div>
              <h2>2.5K+</h2>
              <p>5-Star Reviews</p>
            </div>
          </div>
        </div>

        <img src="/hero1.png" alt="Hero" className="hero-img" />
      </section>

      {/* ================= ABOUT ================= */}
      <section id="about" className="about">
        <div className="about-text">
          <h1 className="section-title">
            About <span>ZestyClothes</span>
          </h1>

          <p className="section-desc">
            At ZestyClothes, we specialize in premium bow ties designed for
            the modern gentleman.
          </p>

          <div className="btn-group">
            <button className="btn-primary">Our Services</button>
            <button className="btn-secondary">Get in Touch</button>
          </div>
        </div>

        <div className="about-images">
          <img src="/bow1.png" alt="Bow1" />
          <img src="/bow2.png" alt="Bow2" />
          <img src="/bow3.png" alt="Bow3" />
          <img src="/bow4.png" alt="Bow4" />
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section id="services" className="services">
        <h1 className="section-title">
          Services <span>We Offer</span>
        </h1>

        <div className="services-grid">
          <div className="service-card">
            <h3>Exclusive Collections</h3>
            <p>Premium handcrafted bow ties with elegant designs.</p>
          </div>

          <div className="service-card">
            <h3>Custom Fit Options</h3>
            <p>Adjustable sizes tailored for comfort and style.</p>
          </div>

          <div className="service-card">
            <h3>Luxury Craftsmanship</h3>
            <p>Made with high-quality fabrics and precision.</p>
          </div>

          <div className="service-card">
            <h3>Satisfaction Guarantee</h3>
            <p>Trusted by thousands of happy customers.</p>
          </div>
        </div>
      </section>

      {/* ================= TESTIMONIALS ================= */}
      <section id="testimonials" className="testimonials">
        <img src="/testimonials.png" alt="Testimonials" />
        <h2 className="testimonial-text">
          "The service from ZestyClothes was exceptional."
        </h2>
        <p className="testimonial-author">— Lucas Evans</p>
      </section>

      {/* ================= CONTACT ================= */}
      <section id="contact" className="contact">
        <img src="/contact.png" alt="Contact" className="contact-img" />

        <div>
          <h1 className="section-title">
            Get in <span>Touch</span>
          </h1>

          <p className="section-desc">
            We’d love to help you find the perfect bow tie.
          </p>

          <div className="contact-info">
            <div className="info-item">
              <FiMail className="contact-icon" />
              <span> zestyclothes100@gmail.com</span>
            </div>

            <div className="info-item">
              <FiPhone className="contact-icon" />
              <span> +91 9354258428</span>
            </div>
          </div>

          <form className="contact-form">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email" />
            <textarea placeholder="Your Message"></textarea>
            <button className="btn-primary">Send Message</button>
          </form>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="footer">
        © 2026 ZestyClothes — All Rights Reserved
      </footer>

    </div>
  );
}
